import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Chats } from "..";
import { getUserAvatar, getUserId, getUserName } from "../../../reducks/users/selectors";
import { TextInput } from "../../UIkit";
import "../../../assets/css/chatBox.css";
import { fechAuthState } from "../../../reducks/users/operations";
import { db, FirebaseTimestamp } from "../../../firebase";

const ChatBox = (props) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const sendId = getUserId(selector);
  const sendName = getUserName(selector);
  const avatar = getUserAvatar(selector);
  const boothId = props.boothId;
  // console.log("sendIDは" + sendId, "sendNameは" + sendName, "avatarは" + avatar);
  //   console.log("boothIDは" + boothId);

  //   const avatar =
  //     "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2F1H_7AxP0.jpg?alt=media&token=2fa04f27-7c33-436f-922f-97ab67fd8cb2";
  //   const sendId = "5Y3wCNsLlAbQVEeAszVD46gp72l2";
  //   const sendName = "test00";
  const [message, setMessage] = useState("");
  const [chats, setChats] = useState([]);
  // console.log("chatsは" + chats);
  // console.log("messageは" + message);

  const inputText = useCallback(
    (event) => {
      setMessage(event.target.value);
    },
    [setMessage]
  );

  const addChats = (chat) => {
    const isBlank = validateRequiredInput(message);
    if (sendId === "") {
      alert("コメントは会員専用機能です");
    } else {
      if (isBlank) {
        alert("空メッセージは送れません");
        return false;
      } else {
        //firestoeに保存してから
        saveChats(chat);
        setChats((prevChats) => {
          return [...prevChats, chat];
        });
      }
      setMessage("");
    }
  };

  const saveChats = async (chats) => {
    const timestamp = FirebaseTimestamp.now();
    const saveRef = db.collection("booths").doc(boothId).collection("chats").doc();
    chats.created_at = timestamp;
    await saveRef.set(chats);
  };

  const chatsListener = () => {
    // console.log("リスナー発火");
    const chatsRef = db.collection("booths").doc(boothId).collection("chats");
    chatsRef.onSnapshot(function (querySnapshot) {
      for (let change of querySnapshot.docChanges()) {
        if (change.type === "added") {
          // データが追加された時
          // もしくは最初の呼び出し
          fechChats();
        } else if (change.type === "modified") {
          // データが変更された時
          fechChats();
        } else if (change.type === "removed") {
          // データが削除された時
          fechChats();
        }
      }
    });
  };

  const fechChats = async () => {
    const chatsRef = db.collection("booths").doc(boothId).collection("chats");
    const snapshots = await chatsRef.orderBy("created_at", "asc").limit(20).get();
    // console.log(snapshots);
    const docs = snapshots.docs.map((doc) => doc.data());
    // console.log(docs);
    setChats(docs);
    // console.log(chats);
  };

  const validateRequiredInput = (...args) => {
    let isBlank = false;
    for (let i = 0; i < args.length; i = (i + 1) | 0) {
      if (args[i] === "") {
        isBlank = true;
      }
    }
    return isBlank;
  };

  useEffect(() => {
    dispatch(fechAuthState());
    chatsListener();
    // fechChats();
    // eslint-disable-next-line
  }, []);
  //   useEffect(() => {
  //     fechChats();
  //     // eslint-disable-next-line
  //   }, [chats]);

  useEffect(() => {
    // console.log("スクロール発火");
    const scrollArea = document.getElementById("scroll-area");
    // console.log(scrollArea);
    if (scrollArea) {
      scrollArea.scrollTop = scrollArea.scrollHeight;
    }
  });

  return (
    <>
      <div className="chat-box center-box">
        <div className="chat-box--inner center">
          <div className="chat-box--message-height">
            <Chats chats={chats} />
          </div>
          <TextInput
            fullWidth={true}
            label={"メッセージを入力"}
            multiline={true}
            required={true}
            onChange={inputText}
            rows={1}
            value={message}
            type={"text"}
          />
          <div className="spacer-box--ss" />
          <div
            className="aleart-btn-style back-primary text-white hover"
            onClick={() => addChats({ message: message, avatar: avatar ?? "", sendName: sendName, sendId: sendId })}
          >
            送信
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatBox;
